import script from "./listSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./listSchedule.vue?vue&type=script&setup=true&lang=js"

import "./listSchedule.vue?vue&type=style&index=0&id=01297990&scoped=true&lang=css"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01297990"]])

export default __exports__